import { PopulatedState } from '@/components/NarrativeCard/PopulatedState';

import { FragmentOf, gql, readFragment } from '@/utilities/gql';
import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard/narrativeCardFragment';
import { NarrativeSetFairValue } from './components/NarrativeSetFairValue';
import { Button, Grid } from '@simplywallst/ui-core';
import { RouterLink } from '@/utilities/redux-first-router.export';
import { ROUTE_PUBLIC_NARRATIVE_EDIT } from '@/constants/routes';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';
import useUser from '@/hooks/useUser';
import { useSelector } from 'react-redux';
import { getLocationPathname } from '@/redux/location/selectors';

export const NARRATIVE_CARD_OPTION_FRAGMENT = gql(
  `
  fragment NarrativeCardOptionFields on Narrative @_unmask {
    id
    isPrimary
    author {
      id
    }
    company {
      id
      canonicalURL
    }
    valuation {
      type
    }
    ...NarrativeCardFields
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

type Props = {
  narrative: FragmentOf<typeof NARRATIVE_CARD_OPTION_FRAGMENT>;
};

export const NarrativeCardOption = ({ narrative }: Props) => {
  const { data: user } = useUser();
  const pathname = useSelector(getLocationPathname);
  const narrativeUnmasked = readFragment(
    NARRATIVE_CARD_OPTION_FRAGMENT,
    narrative
  );
  const { company, id, isPrimary, valuation, author } = narrativeUnmasked;
  const linkTo = ['dcf', 'analysts'].includes(valuation.type)
    ? company?.canonicalURL
    : undefined;

  const isMyNarrative = user.id === author.id;
  return (
    <Grid role="listitem">
      <PopulatedState
        narrative={narrativeUnmasked}
        linkTo={linkTo}
        linkTarget="_blank"
      >
        <Grid templateColumns={isMyNarrative ? 'auto auto' : '1fr'} gap="8px">
          {isMyNarrative && (
            <Button
              as={RouterLink}
              to={{
                type: ROUTE_PUBLIC_NARRATIVE_EDIT,
                payload: {
                  id,
                  query: {
                    company: company?.id.toLowerCase(),
                    referrer: pathname,
                  },
                },
              }}
              styleType="gentleLarge"
              style={{ textAlign: 'center' }}
              alignIcon="left"
            >
              <EditSolid />
              Edit Narrative
            </Button>
          )}
          {company?.id && (
            <NarrativeSetFairValue
              companyId={company.id}
              narrativeId={id}
              isPrimary={isPrimary}
            />
          )}
        </Grid>
      </PopulatedState>
    </Grid>
  );
};
